import Information from './Information'
import Monitoring from './Monitoring'
import Setting from './Setting'
import Statement from './Statement'

const ContentDeliveryNetwork = {
    Information,
    Setting,
    Monitoring,
    Statement,
}

export default ContentDeliveryNetwork
